import { render, staticRenderFns } from "./VehiceListPage.vue?vue&type=template&id=a5af8664&"
import script from "./VehiceListPage.vue?vue&type=script&lang=js&"
export * from "./VehiceListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports